<template>
  <app-layout
    title="Cookies"
    :version="version"
    :bannerSetting="bannerSetting"
    :isUpdate="isUpdate"
  >
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          {{ project.domain_name }}
        </h2>
        <div>
          <jet-button
            class="
              hidden
              cursor-pointer
              inline-flex
              items-center
              px-4
              py-2
              bg-yr-primary-ii-500
              border border-transparent
              rounded-md
              font-semibold
              text-xs text-white
              uppercase
              tracking-widest
              hover:bg-yr-primary-ii-600
              active:bg-yr-primary-ii-700
              focus:outline-none
              focus:border-yr-primary-ii-700
              focus:ring
              focus:ring-yr-primary-ii-300
              transition
            "
          >
            สแกนคุกกี้
          </jet-button>
        </div>
      </div>
    </template>

    <div class="mx-auto sm:px-6 lg:px-8">
      <div
        class="
          text-sm
          font-medium
          text-center text-yr-primary-ii-500
          border-b-xx border-gray-200-xx
        "
      >
        <ul class="flex flex-wrap -mb-px">
          <li
            v-for="(tabContent, index) in tabsContent"
            :key="index"
            class="mr-2"
          >
            <Link
              :href="route(`projects.${tabContent.link}.index`, project)"
              class="inline-block p-4 rounded-t-lg border-b-[3px]"
              :class="
                tabContent.link === lastPath
                  ? 'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'
                  : 'border-transparent hover:border-yr-primary-ii-400'
              "
              >{{ tabContent.title }}</Link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="pb-12">
      <div class="mx-auto sm:px-6 lg:px-8">
        <div
          class="
            p-6
            sm:px-8
            bg-white
            overflow-hidden
            shadow-xl
            sm:rounded-lg
            grid grid-cols-4
            gap-4
          "
        >
          <div
            class="
              col-span-12
              px-6
              py-3
              bg-yr-primary-iii-500-xx
              rounded
              border border-yr-primary-ii-300
            "
          >
            <p class="font-medium text-sm text-yr-primary-iii-900">
              คุกกี้ที่ถูกพบบางชนิดที่เป็นที่รู้จักจะถูกจัดหมวดหมู่
              คุกกี้ที่ถูกจัดหมวดหมู่แล้วจะถูกเพิ่มเข้าไปในเมนู ‘จัดการคุกกี้’
              โดยอัตโนมัติ โดยคุกกี้ที่อยู่ในเมนู ‘จัดการคุกกี้’
              ทั้งหมดจะถูกตั้งค่าให้ถูกบล็อกก่อนได้รับความยินยอมจากผู้ใช้งาน
              ท่านสามารถเพิ่มคุกกี้ได้ด้วยตนเองที่หน้า
              <Link
                :href="route('projects.manage.index', project)"
                class="font-bold text-yr-primary-ii-500 underline"
                >จัดการแบนเนอร์คุกกี้</Link
              >
            </p>
            <br />
            <p class="font-medium text-sm text-yr-primary-iii-900">
              ทีมพัฒนาได้ใช้ความพยายามอย่างเต็มที่ในการตั้งค่าให้ CookiePop
              มีความสามารถในการสแกนคุกกี้ให้ได้มากที่สุด
              แต่อย่างไรก็ตามในบางครั้งเราอาจจะไม่สามารถพบคุกกี้ได้ 100%
              ด้วยปัจจัยที่เราไม่สามารถควบคุมได้ เช่น
              เวลาของการแสดงผลของคุกกี้ของแต่ละเว็บไซต์
              เราจึงแนะนำให้ทางเจ้าของเว็บไซต์ตรวจสอบเองอีกครั้ง
            </p>
          </div>
          <div class="col-span-12 overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500 table-auto">
              <thead
                class="
                  text-xs text-yr-primary-ii-500
                  uppercase
                  bg-yr-primary-iii-500
                "
              >
                <tr>
                  <th scope="col" class="px-6 py-3">ชื่อ</th>
                  <th scope="col" class="px-6 py-3">ผู้ให้บริการ</th>
                  <th scope="col" class="px-6 py-3">โดเมน / URL</th>
                  <th scope="col" class="px-6 py-3">ประเภท</th>
                  <th scope="col" class="px-6 py-3">ระยะเวลาคุกกี้</th>
                  <th scope="col" class="px-6 py-3">หมวดหมู่ของคุกกี้</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="cookies.data.length === 0">
                  <td
                    colspan="6"
                    class="
                      px-6
                      py-4
                      font-medium
                      text-gray-900
                      border-b
                      bg-white
                      text-center
                    "
                  >
                    ไม่พบคุกกี้จากการสแกน
                  </td>
                </tr>
                <tr
                  v-for="(cookie, index) in cookies.data"
                  :key="index"
                  class="bg-white border-b hover:bg-gray-50"
                >
                  <td
                    scope="row"
                    class="
                      px-6
                      py-4
                      font-medium
                      text-gray-900
                      whitespace-nowrap
                    "
                  >
                    {{ cookie.name ?? "-" }}
                  </td>
                  <td class="px-6 py-4 text-gray-900">
                    {{ cookie.provider ?? "-" }}
                  </td>
                  <td
                    class="
                      px-6
                      py-4
                      text-gray-900
                      max-w-[350px]
                      truncate-xxx
                      break-words
                    "
                  >
                    {{ cookie.url ?? "-" }}
                  </td>
                  <td class="px-6 py-4 text-gray-900">
                    {{ cookie.type ?? "-" }}
                  </td>
                  <td class="px-6 py-4 text-gray-900">
                    {{ cookie.expiry ?? "-" }}
                  </td>
                  <td class="px-6 py-4 text-gray-900">
                    <select
                      class="border border-gray-200 rounded-md"
                      v-model="cookie.category"
                      @change="changeCookieCate(cookie)"
                    >
                      <option
                        disabled
                        :value="null"
                        aria-placeholder="ยังไม่ถูกจัดหมวดหมู่"
                      >
                        ยังไม่ถูกจัดหมวดหมู่
                      </option>
                      <option
                        v-for="(cookieCate, index) in cookieCates"
                        :key="index"
                        :value="cookieCate.type"
                      >
                        {{ cookieCate.type }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="flex justify-center">
              <pagination class="mt-6" :links="cookies.links" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import moment from "moment";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import { Link } from "@inertiajs/inertia-vue3";
import Pagination from "@/Components/Pagination";

export default defineComponent({
  props: [
    "project",
    "cookies",
    "allCookies",
    "bannerSetting",
    "version",
  ],

  components: {
    AppLayout,
    Link,
    JetButton,
    JetInput,
    Pagination,
  },

  data() {
    return {
      tabsContent: [
        {
          title: "บันทึกความยินยอม",
          link: "consents",
        },
        {
          title: "สแกนคุกกี้",
          link: "cookies",
        },
        {
          title: "จัดการคุกกี้",
          link: "manage",
        },
        {
          title: "ปรับแต่งแบนเนอร์",
          link: "dialogs",
        },
        // {
        //   title: "ตั้งค่าแบนเนอร์",
        //   link: "banner_setting",
        // },
      ],
      isUpdate: false,
    };
  },

  computed: {
    lastPath() {
      return window.location.pathname.split("/").pop();
    },
    bannerCustomize() {
      return JSON.parse(this.bannerSetting.customize);
    },
    cookieCates() {
      return JSON.parse(this.bannerSetting.customize).cookies;
    },
    javaScriptCates() {
      return JSON.parse(this.bannerSetting.customize).javaScripts;
    },
  },

  methods: {
    getHumanDate(date) {
      return moment(date).format("YYYY-MM-DD h:mm");
    },

    changeCookieCate(cookie) {
      // map input ที่เลือกไว้ใน cookie ทั้งหมดเนื่องจากมี pagination v-model เลยเข้าไม่ถึง
      this.allCookies.map((elm) => {
        if (elm.id === cookie.id) {
          elm.category = cookie.category;
        }
      });

      // แยกประเภท cookie
      let ck = this.allCookies.filter((elm) => elm.type === "cookie");
      let sc = this.allCookies.filter((elm) => elm.type === "script");

      // map ประเภท cookie เข้า bannerSetting
      this.cookieCates.map((cate) => {
        cate.keys = [];

        ck.forEach((elm) => {
          if (cate.type === elm.category) {
            cate.keys.push(elm.name);
          }
        });
      });
      this.bannerCustomize.cookies = this.cookieCates;

      this.javaScriptCates.map((cate) => {
        cate.keys = [];

        sc.forEach((elm) => {
          if (cate.type === elm.category) {
            cate.keys.push(elm.url);
          }
        });
      });
      this.bannerCustomize.javaScripts = this.javaScriptCates;

      // set version ข้างใน customize เผื่อเผยแพร่
      // this.bannerCustomize.version = this.version.version + 1;

      // store input ข้างต้น
      axios
        .post(route("change.cookie.cate"), {
          id: cookie.id,
          cate: cookie.category,
          customize: this.bannerCustomize,
          projectId: this.project.id,
        })
        .then(() => {})
        .catch((error) => {});

      this.isUpdate = true;
    },
  },
});
</script>
